import { Messages } from '~src/codegen/Localize';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import React = require('react');
import { ButtonType, ButtonWidget } from '@tableau/widgets';

export interface DisplayWindowsCredentialsLinkProps {
    autoLoginDidFail: boolean;
    retryAutoLogin: () => void;
}

export function DisplayWindowsCredentialsLink(props: DisplayWindowsCredentialsLinkProps) {
    // In SSPI/Kerberos, for the case of SwitchUser, you get redirected to the login page with disableAutoSignIn=true.
    // That way we show Username+Password instead of kicking off the AutoLogin flow, and offer an option to kick it off manually.
    // We save a state, if it fails we don't allow the user to try again, as it will continue failing.
    if (props.autoLoginDidFail) {
        return null;
    }

    // Keeping this legacy behavior of showing the user name of the currently authenticated user.
    // Clicking the button will trigger a new autoLogin and there's absolutely no evidence that it will authenticate 
    // as the same user again. And no point in doing it anyway. 
    const displayName = getSessionManagementServiceInstance().sessionUserDisplayName();
    return <div className='tb-login-windows-credentials'>
        <ButtonWidget
            buttonType={ButtonType.Outline}
            testId='windows-credentials-login'
            onClick={props.retryAutoLogin}>
                {displayName ? Messages.signInAsUser({ USER: displayName }) : Messages.signInUsingWindowsCredentials()}
        </ButtonWidget>
    </div>;
}